import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ColumnEditorDropDown from 'src/components/ColumnEditorDropDown';
import Button from 'src/components/design-system/Button';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import { SuppliersContext } from 'src/sections/manage_suppliers/SuppliersContext';
import { ManageSupplierTypeFilterItem } from 'src/types/manage-suppliers/ManageSupplier';
import { useContextSelector } from 'use-context-selector';
import StatusFilterDropdown from './StatusFilterDropdown';

const SuppliersToolbarActions = () => {
  const { t } = useTranslation();
  const hasActiveFilters = useContextSelector(SuppliersContext, (ctx) => ctx.hasActiveFilters);
  const clearFilters = useContextSelector(SuppliersContext, (ctx) => ctx.clearFilters);
  const canManageSuppliers = useContextSelector(SuppliersContext, (ctx) => ctx.canManageSuppliers);
  const openCreateSupplierPanel = useContextSelector(
    SuppliersContext,
    (ctx) => ctx.openCreateSupplierPanel
  );
  const supplierTypeFilter = useContextSelector(SuppliersContext, (ctx) => ctx.supplierTypeFilter);
  const setSupplierTypeFilter = useContextSelector(
    SuppliersContext,
    (ctx) => ctx.setSupplierTypeFilter
  );
  const supplierTypeDropdownData = useMemo(
    () => supplierTypeFilter.map((item) => ({ ...item, title: t(item.title) })),
    [supplierTypeFilter, t]
  );

  return (
    <div className="manage-suppliers-toolbar flex w-full flex-row flex-wrap items-center gap-x-2 gap-y-2">
      <div className="manage-suppliers-toolbar__actions flex min-w-0 flex-row flex-wrap items-center gap-2">
        <ClearFilterButton onClick={clearFilters} disabled={!hasActiveFilters} />
        {canManageSuppliers && (
          <Button color="primary" size="lg" onClick={openCreateSupplierPanel}>
            {t('Create New Offline Supplier')}
          </Button>
        )}
      </div>
      <div className="manage-suppliers-toolbar__filters ml-auto flex min-w-0 flex-row flex-wrap items-center justify-end gap-2">
        <div className="min-w-0 w-[200px]">
          <ColumnEditorDropDown
            data={supplierTypeDropdownData}
            onChange={(items) => setSupplierTypeFilter(items as ManageSupplierTypeFilterItem[])}
            label={t('All Suppliers')}
            value={t('All Suppliers')}
          />
        </div>

        <StatusFilterDropdown />
      </div>
    </div>
  );
};

export default SuppliersToolbarActions;
